import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction } from 'redux-actions';
import { PATH_DELIMITER, SYSTEM_LOGIN_HISTORY_PATH } from "../../../constant/Constant";
import NullCheckUtil from "../../../util/NullCheckUtil";
import { request } from '../../ApiModule';
import { SET_GRID_DATA } from '../../component/TableBoxModule';

const ACTION_LOGIN_HISTORY_SEARCH = SYSTEM_LOGIN_HISTORY_PATH + PATH_DELIMITER + 'ACTION_LOGIN_HISTORY_SEARCH';
export const actionLoginHistorySearch = createAction(ACTION_LOGIN_HISTORY_SEARCH);

export function* systemLoginHistorySagas() {
    yield takeEvery(ACTION_LOGIN_HISTORY_SEARCH, actionLoginHistorySearchSaga);
}

function* actionLoginHistorySearchSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'get',
        url: '/api/login-history',
        params,
        callback,
    });

    if (NullCheckUtil.isNotEmpty(result)) {
        yield put({
            type: SET_GRID_DATA,
            payload: result,
        });
    }
}